import React from 'react'
import './index.less'
export default class Home extends React.Component{

    render(){
        return (
            <div className="home-wrap">
                寻梦后台管理系统
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/index.js